import { render, staticRenderFns } from "./gestionPeligro.vue?vue&type=template&id=6dc3b430&"
import script from "./gestionPeligro.vue?vue&type=script&lang=js&"
export * from "./gestionPeligro.vue?vue&type=script&lang=js&"
import style0 from "./gestionPeligro.vue?vue&type=style&index=0&id=6dc3b430&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports